<script setup lang="ts">
import { computed } from 'vue'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { isLegalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { KycProvider } from '../../../utilities/api'
import { kycProviderExternal } from '../../../utilities/helpers'
import { getAccountLink } from '../../../utilities/useLinks'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import AccountKycProcessStatusIDNow from '../../account/personal/verification/AccountKycProcessStatusIDNow.vue'
import AccountKycProcessStatusSignteq from '../../account/personal/verification/AccountKycProcessStatusSignteq.vue'

const personalAccountDataStore = usePersonalAccountDataState()

const showKycAlert = computed(() => personalAccountDataStore.naturalProfile.kyc_id === false && !isLegalProfile())
</script>

<template>
    <div v-if="showKycAlert" class="overflow-hidden rounded-lg border">
        <div class="px-6 py-4">
            <h3 class="flex text-xl font-bold text-gray-900">
                {{ $t('investment_process.verification_outstanding') }}
            </h3>
            <p class="mt-2 font-medium text-gray-500">
                {{ $t('investment_process.verification_outstanding_description') }}
            </p>
            <AccountKycProcessStatusIDNow
                v-if="
                    kycProviderExternal &&
                    personalAccountDataStore.naturalProfile.platform_kyc_provider === KycProvider.IDNOW
                " />
            <AccountKycProcessStatusSignteq
                v-if="
                    kycProviderExternal &&
                    personalAccountDataStore.naturalProfile.platform_kyc_provider === KycProvider.SIGNTEQ
                " />
            <BaseButtonMuted v-else class="mt-4" size="lg" :href="getAccountLink() + '?menu=Verification'">
                {{ $t('investment_process.verify_button') }}
            </BaseButtonMuted>
        </div>
    </div>
</template>
